import React, { useState, useEffect } from 'react';
import {
    Button,
    Col,
    FormGroup,
    Label,
    Input,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
} from 'reactstrap';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { useDispatch } from 'react-redux';
import { fazendaAction, relatorioAction } from '../_actions';

export const ModalFichaAnimal = ({ openModalFichaAnimal, handleCloseModalFichaAnimal, props }) => {
    const [fazendaSelecionada, setFazendaSelecionada] = useState(0);
    const [dataInicio, setDataInicio] = useState('');
    const [dataFim, setDataFim] = useState('');
    const dispatch = useDispatch();

    useEffect(() => {
        if (openModalFichaAnimal) {
            dispatch(fazendaAction.getFazendaSelect());
        }
    }, [openModalFichaAnimal, dispatch]);

    const handleSelectChange = prop => event => {
        if (prop === 'id_fazenda') {
            setFazendaSelecionada(event.value);
        }
    };

    const renderOptionsFazenda = () => {
        return (props.fazenda && props.fazenda.fazenda ? props.fazenda.fazenda : []).map((p, i) => {
            return (
                { value: p.id, label: p.nome }
            );
        });
    };

    const handleGeraRelatorio = () => {

        if (fazendaSelecionada !== '' && fazendaSelecionada !== 0) {
            let payload = {
                id_fazenda: fazendaSelecionada,
                tipo_relatorio: "FA"
            };
            
            if (dataInicio) payload.data_inicio = dataInicio;
            if (dataFim) payload.data_termino = dataFim;

            dispatch(relatorioAction.getRelatorio(payload, true));
        } else {
            Swal.fire({
                icon: 'warning',
                title: 'Erros de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left">Selecione uma fazenda</div>'
            });
        }
    }

    return (
        <div>
        <Modal isOpen={openModalFichaAnimal} onClose={handleCloseModalFichaAnimal} aria-labelledby="form-dialog-title">
            <ModalHeader id="form-dialog-title">Gerar Ficha do Animal</ModalHeader>
            <ModalBody>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label className="left" for="selecionarFazenda">Selecione uma fazenda: *</Label>
                            {openModalFichaAnimal &&
                                <Select
                                    classNamePrefix="select"
                                    value={renderOptionsFazenda().filter(function (option) {
                                        return option.value === (fazendaSelecionada || 0);
                                    })}
                                    onChange={handleSelectChange('id_fazenda')}
                                    isSearchable
                                    placeholder="Selecione..."
                                    id="id_fazenda"
                                    name="id_fazenda"
                                    options={renderOptionsFazenda()}
                                />
                            }
                        </FormGroup>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col>
                        <Label className="left" for="data_inicio_descarte">Data de Saída Início:</Label>
                        <Input
                            id="data_inicio_descarte"
                            className="form-control"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            value={dataInicio}
                            onChange={(e) => setDataInicio(e.target.value)}
                        />
                    </Col>
                    <Col>
                            <Label className="left" for="data_fim_descarte">Data de Saída Fim:</Label>
                        <Input
                            id="data_fim_descarte"
                            className="form-control"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            value={dataFim}
                            onChange={(e) => setDataFim(e.target.value)}
                        />
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button onClick={handleCloseModalFichaAnimal} color="secondary">Cancelar</Button>
                <Button onClick={handleGeraRelatorio} color="primary">Gerar Ficha</Button>
            </ModalFooter>
        </Modal>
        </div>
    )
}
